import { useMutation } from '@tanstack/vue-query';
import httpClient from '../httpClient';
import type { ClientSelection } from '@/types';
import type { SpeciesKey } from '@/lib/species';

export interface CreateClientWithPatientsPayload {
  first_name?: string;
  last_name: string;
  phone_number?: string;
  email?: string;
  patients: { name: string; species?: SpeciesKey }[];
}

export interface CreateClientWithPatientsResult {
  selection: ClientSelection;
  /** Names of animals the server could not save. */
  failedPatients: string[];
}

export const useClientCreateWithPatients = () => {
  return useMutation({
    mutationFn: async (
      payload: CreateClientWithPatientsPayload,
    ): Promise<CreateClientWithPatientsResult> => {
      const response = await httpClient.post<
        ClientSelection & { failedPatients?: string[] }
      >('/v1/clients/with-patients', payload);
      const { failedPatients, ...selection } = response.data;
      return { selection, failedPatients: failedPatients ?? [] };
    },
  });
};
